import {connect} from 'react-redux';
import SingleArticle from '../../components/SingleArticle';
import {loadArticles} from '../../actions';

function mapStateToProps(state) {
  return {
    article: state.article
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadArticles: tag => dispatch(loadArticles(tag))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SingleArticle);
